export default __webpack_public_path__ + "static/media/FlyingFrog11.4e09f78e.png";